
import { Component, Prop } from 'vue-property-decorator';
  import CreateFlowForm from './create.vue';

@Component
export default class EditFlowForm extends CreateFlowForm {
  @Prop({ default: {} })
  data: any;
  
  get header() {
    return this.t('Edit Flow');
  }

  async load() {
    this.edit = true;
    this.flow_id = this.data.id || this.$store.getters.selectedItem.id;

    await this.flowApi.get(this.flow_id).then((data: any) => {
      this.form = data;
    });
  }

  onSubmit() {
    return this.flowApi
      .putUpdate(this.flow_id, this.processForm(this.form))
      .then((res) => {
        const { id } = res.data.payload;
        this.reportUtils.updateName('flows', id);
        this.trackAnalytics('flow_edit')
        this.data?.onConfirm?.(res.data.payload)
        return Promise.resolve(res);
      })}
}
